import { render, staticRenderFns } from "./BatchTable.vue?vue&type=template&id=1a599730&scoped=true&"
import script from "./BatchTable.vue?vue&type=script&lang=js&"
export * from "./BatchTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchTable.vue?vue&type=style&index=0&id=1a599730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a599730",
  null
  
)

export default component.exports